module.exports = __webpack_public_path__ + "img/icon_lesson-amount.02d3c1cd.png";